const filteredItems = (toc, items, range) => {
  let chaptersGroup = []

  if (toc.length === 0) {
    return items
  }

  toc.forEach((t, n) => {
    let itemsArray = []
    const createPagesRange = () => {
      let pagesRange = []
      let length

      (n + 1) === toc.length ? length = range - t.pages[0].position : length = toc[(n + 1)].pages[0].position - t.pages[0].position

      for (let i = 0; i < length; i++) {
        pagesRange.push(t.pages[0].position + i)
      }

      return pagesRange
    }

    createPagesRange().forEach(tp => {
      items.filter(element => {
        if (element.page === tp) {
          itemsArray.push(element)
        }
      })
    })

    if (itemsArray.length > 0) {
      chaptersGroup.push({
        title: t.name,
        elements: itemsArray
      })
    }
  })

  return chaptersGroup
}

export default filteredItems
